import gql from 'graphql-tag';

export const removeCategoryMutation = gql`
  mutation RemoveCategory($id: ID!) {
    removeCategory(id: $id)
  }
`;
